export default __webpack_public_path__ + "static/media/circle-two.c91b4be0.svg";